import { render } from "./AppFileUploadOCR.vue?vue&type=template&id=e1f7329e&scoped=true"
import script from "./AppFileUploadOCR.vue?vue&type=script&lang=js"
export * from "./AppFileUploadOCR.vue?vue&type=script&lang=js"

import "./AppFileUploadOCR.vue?vue&type=style&index=0&id=e1f7329e&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f7329e"]])

export default __exports__